import React, { ReactNode, useEffect, useState } from 'react';

import { BasicDialog, BasicDialogProps } from '../../core-ui/BasicDialog';
import { EventEmitter } from '../../support/helpers/EventEmitter';

type DialogDescriptor = Omit<BasicDialogProps, 'isOpen' | 'onHide'>;

type EventMap = {
  showDialog: [DialogDescriptor];
};

const emitter = new EventEmitter<EventMap>();

export function AppDialog() {
  const [dialog, setDialog] = useState<DialogDescriptor | null>(null);

  useEffect(() => {
    return emitter.addListener('showDialog', (payload) => {
      setDialog(payload);
    });
  }, []);

  return (
    <BasicDialog
      isOpen={dialog != null}
      title={dialog?.title ?? ''}
      content={dialog?.content ?? ''}
      buttons={dialog?.buttons}
      options={dialog?.options}
      onSubmit={dialog?.onSubmit}
      onHide={() => setDialog(null)}
    />
  );
}

export function showDialog(
  title: string,
  content: string | (() => ReactNode),
  buttons?: Array<string>,
  onSubmit?: (button: string, formData: Record<string, unknown>) => void,
  options?: BasicDialogProps['options'],
) {
  emitter.emit('showDialog', { title, content, buttons, options, onSubmit });
}

export function confirm(title: string, content: string) {
  return new Promise<boolean>((resolve) => {
    const OK = t('OK');
    const CANCEL = t('Cancel');
    emitter.emit('showDialog', {
      title,
      content,
      buttons: [CANCEL, OK],
      onSubmit: (choice) => {
        const shouldProceed = choice !== CANCEL;
        resolve(shouldProceed);
      },
    });
  });
}
